import { render } from "./sf.vue?vue&type=template&id=bc10df34&scoped=true"
import script from "./sf.vue?vue&type=script&lang=js"
export * from "./sf.vue?vue&type=script&lang=js"

import "./sf.vue?vue&type=style&index=0&id=bc10df34&lang=scss&scoped=true"

import exportComponent from "E:\\My Websites\\v12\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc10df34"]])

export default __exports__